/**
 * auth-token-response.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { validateAs, validateFor } from "../../validation/decorators";
import { IncomingMessage } from "../general/incoming-message";
import { MessageTag } from "../message-tag";

/**
 * The {@link AuthTokenResponse} is sent by the server after successfully
 * generating an authentication token for logging in without normal credentials.
 * (This is most commonly used when opening a session into a new tab.)
 */
@validateFor(MessageTag.RSP_AUTH_TOKEN)
export class AuthTokenResponse extends IncomingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.RSP_AUTH_TOKEN;

  /**
   * The server-generated authentication token for this user
   * @type {string}
   */
  @validateAs("string")
  public token : string;
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/auth/auth-token-response.ts